import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  Col,
  Container,
  Fade,
  Form,
  FormGroup,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import { clear, getUsers, login } from "../redux/actions/authActions";
import Footer from "./partials/Footer";
import Header from "./partials/Header";

const Login = (props) => {
  useEffect(() => {
    document.body.classList.add("img-bg");
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const history = useHistory();
  return (
    <Fragment>
      <Header {...props} background={false} login={false} />
      <div className="margin-top-fix text-white-1">
        <Container>
          <Row className="mb-5">
            <Col lg={6}>
              <div className="d-flex justify-content-center mt-5 pt-5 align-items-center">
                <div>
                  <h4>Welcome to ClueRush </h4>
                  <h5 className="mt-4">
                    Sign In with your data that you entered
                    <br />
                    during your Registration
                  </h5>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mt-5 mt-lg-0">
              <div className="form-wrapper">
                {auth.login && auth.login.code == 400 && (
                  <Fade
                    in={auth.login && auth.login.message}
                    onEnter={(e) =>
                      window.setTimeout(() => {
                        dispatch(clear("login"));
                      }, 2000)
                    }
                  >
                    <Alert
                      isOpen={auth.login && auth.login.message}
                      color="danger"
                    >
                      {auth.login && auth.login.message}
                    </Alert>
                  </Fade>
                )}
                {auth.login && auth.login.code == 200 && (
                  <Fade
                    in={auth.login && auth.login.message}
                    onEnter={(e) =>
                      window.setTimeout(() => {
                        dispatch(clear("login"));
                        history.push("/login");
                      }, 5000)
                    }
                  >
                    <Alert
                      isOpen={auth.login && auth.login.message}
                      color="success"
                    >
                      {auth.login && auth.login.message}
                    </Alert>
                  </Fade>
                )}
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    let obj = {
                      email: e.target.email.value,
                      password: e.target.password.value,
                    };
                    dispatch(login(obj));
                  }}
                >
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Email"
                      className="form-control"
                      name="email"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="password"
                      placeholder="Password"
                      minLength={8}
                      className="form-control mt-3"
                      name="password"
                    />
                  </FormGroup>
                  <Button
                    type="submit"
                    block
                    disabled={auth.login == -1}
                    className="w-100 mt-3 bg-purple-1 border-0 py-4"
                    style={{ borderRadius: 24 }}
                  >
                    {auth.login == -1 ? <Spinner /> : "Sign In"}
                  </Button>
                </Form>
                <small className="d-block mt-5 text-center">
                  Or Connect with
                </small>
                <div className="social-icons text-center mt-4">
                  <span className="facebook icon me-4">
                    <i className="fab fa-facebook-f"></i>
                  </span>
                  <span className="google icon me-4">
                    <i className="fab fa-google"></i>
                  </span>
                  <span className="twitter icon">
                    <i className="fab fa-twitter"></i>
                  </span>
                </div>
                <small className="d-block mt-5 text-center font-2 text-capitalize">
                  don’t have an account ?{" "}
                  <Link
                    to="/register"
                    className="text-red-1"
                    style={{ fontWeight: 700, textDecoration: "none" }}
                  >
                    Sign Up
                  </Link>
                </small>
                <small className="d-block mt-5 text-center font-2 text-capitalize">
                  forgot password ?{" "}
                  <Link
                    to="/forgetpassword"
                    className="text-red-1"
                    style={{ fontWeight: 700, textDecoration: "none" }}
                  >
                    Recover Account
                  </Link>
                </small>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <br />
      <br />
      <br />
      <Footer></Footer>
    </Fragment>
  );
};

export default Login;
